import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController, useModel } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageUI } from "components/pages/TransfersPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes from "model";

/**
 * @name CaptureTransferTemplatesDD
 * @returns {React.Component}
 * @description The capture component "020_TransferTemplates_DD" in capture group "Transfers - Recurring".
 */
export default function CaptureTransferTemplatesDD(props) {
    const globalController = useGlobalController();
    const { branding } = useModel();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, globalController))
    .update([ "template", "isActive" ], true)
    .submit();

    if(branding.options.transfer_templates_abi22 !== "true") {
        const message = `This capture is only shown when ABI22 branding option "Transfer Templates" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <TransfersPage ui={ ui } />
}